module.exports = __webpack_public_path__ + "static/media/ViewBiller.b9e80e9d.svg";